(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const stage = document.querySelector('.sc-hero-stage');
    const lb = document.querySelector('.sc-lb-viewer');
    if (!stage || !lb || stage.dataset.lightboxReady) return;
    stage.dataset.lightboxReady = '1';
    const slides = [...stage.querySelectorAll('.sc-hero-slide')];
    const photos = slides.map(slide => slide.querySelector('img')).filter(Boolean);
    const viewport = lb.querySelector('.sc-lb-viewport');
    const image = lb.querySelector('.sc-lb-img');
    const close = lb.querySelector('.sc-lb-close');
    const prev = lb.querySelector('.sc-lb-prev');
    const next = lb.querySelector('.sc-lb-next');
    const zoom = lb.querySelector('.sc-lb-zoom');
    const points = new Map();
    let index = 0, scale = 1, x = 0, y = 0, width = 0, height = 0;
    let gesture = null, moved = false, pinched = false, opener = null, saved = null;
    let background = [];
    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
    const isOpen = () => lb.classList.contains('open');
    lb.querySelector('.sc-lb-total').textContent = photos.length;
    prev.hidden = next.hidden = photos.length < 2;

    function draw() {
      const maxX = Math.max(0, (width * scale - viewport.clientWidth) / 2);
      const maxY = Math.max(0, (height * scale - viewport.clientHeight) / 2);
      x = clamp(x, -maxX, maxX);
      y = clamp(y, -maxY, maxY);
      image.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px) scale(${scale})`;
      lb.dataset.zoom = scale.toFixed(3);
      viewport.classList.toggle('is-zoomed', scale > 1.01);
      zoom.textContent = scale > 1.01 ? '−' : '+';
      zoom.setAttribute('aria-label', scale > 1.01 ? lb.dataset.resetLabel : lb.dataset.zoomLabel);
    }
    function reset() {
      points.clear(); gesture = null; scale = 1; x = y = 0;
      viewport.classList.remove('is-dragging');
      draw();
    }
    function fit() {
      if (!isOpen() || !image.naturalWidth) return;
      const ratio = Math.min(viewport.clientWidth / image.naturalWidth, viewport.clientHeight / image.naturalHeight, 1);
      width = image.naturalWidth * ratio; height = image.naturalHeight * ratio;
      image.style.width = width + 'px'; image.style.height = height + 'px';
      reset();
      image.style.visibility = 'visible';
    }
    function show(i) {
      index = (i + photos.length) % photos.length;
      reset();
      image.style.visibility = 'hidden';
      image.alt = photos[index].alt;
      image.src = photos[index].dataset.full || photos[index].currentSrc || photos[index].src;
      lb.querySelector('.sc-lb-cur').textContent = index + 1;
      if (image.complete) fit();
    }
    image.addEventListener('load', fit);
    function open(photo) {
      if (!photos.includes(photo) || isOpen()) return;
      opener = photo;
      saved = { css: document.body.style.cssText, x: window.scrollX, y: window.scrollY };
      document.body.appendChild(lb);
      background = [...document.body.children].filter(el => el !== lb && !['SCRIPT', 'STYLE', 'LINK'].includes(el.tagName)).map(el => [el, el.inert]);
      background.forEach(([el]) => { el.inert = true; });
      Object.assign(document.body.style, { position: 'fixed', top: -saved.y + 'px', left: -saved.x + 'px', width: '100%', overflow: 'hidden' });
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      show(photos.indexOf(photo));
      close.focus({ preventScroll: true });
    }
    function hide() {
      if (!isOpen()) return;
      reset();
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      background.forEach(([el, inert]) => { el.inert = inert; });
      background = [];
      document.body.style.cssText = saved.css;
      window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
      opener?.focus({ preventScroll: true });
    }
    photos.forEach(photo => {
      photo.setAttribute('role', 'button');
      photo.setAttribute('aria-haspopup', 'dialog');
      photo.setAttribute('aria-label', lb.dataset.openLabel);
      photo.addEventListener('click', () => open(photo));
      photo.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(photo); }
      });
    });
    function syncTabStops() {
      photos.forEach(photo => { photo.tabIndex = photo.closest('.sc-hero-slide').style.pointerEvents === 'none' ? -1 : 0; });
    }
    new MutationObserver(syncTabStops).observe(stage, { attributes: true, attributeFilter: ['style'], subtree: true });
    syncTabStops();
    function activate(button, action) {
      let start = null, suppressUntil = 0;
      button.addEventListener('pointerdown', e => {
        if (e.pointerType === 'touch') start = { id: e.pointerId, x: e.clientX, y: e.clientY };
      });
      button.addEventListener('pointercancel', () => { start = null; });
      button.addEventListener('pointerup', e => {
        if (!start || start.id !== e.pointerId) return;
        const tap = Math.hypot(e.clientX - start.x, e.clientY - start.y) < 10;
        start = null;
        if (tap) {
          e.preventDefault();
          suppressUntil = performance.now() + 700;
          action();
        }
      });
      button.addEventListener('click', e => {
        if (e.detail > 0 && performance.now() < suppressUntil) { e.preventDefault(); return; }
        action();
      });
    }
    activate(close, hide);
    activate(prev, () => show(index - 1));
    activate(next, () => show(index + 1));
    lb.addEventListener('click', e => { if (e.target === lb) hide(); });
    function zoomAt(px, py) {
      if (scale > 1.01) { reset(); return; }
      const rect = viewport.getBoundingClientRect();
      const dx = px - rect.left - rect.width / 2, dy = py - rect.top - rect.height / 2;
      scale = 2.5; x = dx * (1 - scale); y = dy * (1 - scale); draw();
    }
    activate(zoom, () => {
      const r = viewport.getBoundingClientRect(); zoomAt(r.left + r.width / 2, r.top + r.height / 2);
    });
    const local = e => {
      const r = viewport.getBoundingClientRect();
      return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 };
    };
    function begin() {
      const p = [...points.values()];
      if (!p.length) { gesture = null; return; }
      gesture = { x, y, scale, start: p[0], distance: p.length > 1 ? Math.hypot(p[1].x - p[0].x, p[1].y - p[0].y) : 0,
        center: p.length > 1 ? { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 } : p[0] };
    }
    viewport.addEventListener('pointerdown', e => {
      if (e.button !== 0 || !image.complete || !image.naturalWidth) return;
      if (!points.size) { moved = false; pinched = false; }
      points.set(e.pointerId, local(e));
      viewport.setPointerCapture(e.pointerId);
      if (points.size > 1) pinched = true;
      begin();
      viewport.classList.toggle('is-dragging', scale > 1);
    });
    viewport.addEventListener('pointermove', e => {
      if (!points.has(e.pointerId) || !gesture) return;
      points.set(e.pointerId, local(e));
      const p = [...points.values()];
      if (p.length > 1 && gesture.distance > 0) {
        scale = clamp(gesture.scale * Math.hypot(p[1].x - p[0].x, p[1].y - p[0].y) / gesture.distance, 1, 5);
        const ratio = scale / gesture.scale;
        x = (p[0].x + p[1].x) / 2 - (gesture.center.x - gesture.x) * ratio;
        y = (p[0].y + p[1].y) / 2 - (gesture.center.y - gesture.y) * ratio;
        moved = true;
      } else {
        const dx = p[0].x - gesture.start.x, dy = p[0].y - gesture.start.y;
        if (Math.hypot(dx, dy) > 6) moved = true;
        if (scale > 1) { x = gesture.x + dx; y = gesture.y + dy; }
      }
      draw();
    });
    function finish(e) {
      if (!points.has(e.pointerId)) return;
      const pos = local(e), start = gesture?.start;
      const last = points.size === 1, cancelled = e.type !== 'pointerup';
      points.delete(e.pointerId);
      if (viewport.hasPointerCapture(e.pointerId)) viewport.releasePointerCapture(e.pointerId);
      if (last && !cancelled && !pinched) {
        if (!moved && e.pointerType === 'mouse') {
          const r = image.getBoundingClientRect();
          if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) zoomAt(e.clientX, e.clientY);
          else hide();
        } else if (moved && scale === 1 && e.pointerType !== 'mouse' && start) {
          const dx = pos.x - start.x, dy = pos.y - start.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
        }
      }
      begin();
      if (!points.size) viewport.classList.remove('is-dragging');
    }
    viewport.addEventListener('pointerup', finish);
    viewport.addEventListener('pointercancel', finish);
    viewport.addEventListener('lostpointercapture', finish);
    image.addEventListener('dragstart', e => e.preventDefault());
    lb.addEventListener('keydown', e => {
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); hide(); }
      else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoom.click(); }
      else if (e.key === '-' || e.key === '0') { e.preventDefault(); reset(); }
      else if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
        e.preventDefault();
        if (scale > 1) {
          if (e.key === 'ArrowLeft') x += 60;
          if (e.key === 'ArrowRight') x -= 60;
          if (e.key === 'ArrowUp') y += 60;
          if (e.key === 'ArrowDown') y -= 60;
          draw();
        } else if (e.key === 'ArrowLeft') show(index - 1);
        else if (e.key === 'ArrowRight') show(index + 1);
      } else if (e.key === 'Tab') {
        const buttons = [...lb.querySelectorAll('button')].filter(b => !b.hidden);
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('resize', () => { if (isOpen()) fit(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-announcement"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const banner = document.querySelector('.sc-announcement');
    if (banner && !banner.hasAttribute('data-rotating')) {
        banner.setAttribute('data-rotating', '');
        const toggle = banner.querySelector('.sc-announcement-toggle');
        toggle.addEventListener('click', () => {
            const paused = banner.toggleAttribute('data-paused');
            toggle.setAttribute('aria-label', paused ? toggle.dataset.resume : toggle.dataset.pause);
            toggle.textContent = paused ? '▶' : 'Ⅱ';
        });
        const syncVisibility = () => banner.toggleAttribute('data-tab-hidden', document.hidden);
        document.addEventListener('visibilitychange', syncVisibility);
        syncVisibility();
    }
    let previous;
    const update = () => {
        const next = window.scrollY <= 1 ? 'visible' : 'hidden';
        if (next !== previous) {
            root.dataset.scAnnouncement = next;
            previous = next;
        }
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('pageshow', update);
    update();
})();
  } catch(e) { console.error(e); }
})();

})();
